var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGmailStandalone = function SvgGmailStandalone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gmail-standalone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M1.636 18h3.819V8.727L0 4.637v11.727C0 17.269.734 18 1.636 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M18.546 18h3.818c.905 0 1.636-.734 1.636-1.636V4.636l-5.454 4.091"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M18.546 1.636v7.091L24 4.637V2.454C24 .43 21.69-.723 20.073.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M5.455 8.727v-7.09L12 6.544l6.545-4.909v7.091L12 13.637"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5221F",
    d: "M0 2.455v2.181l5.455 4.091v-7.09L3.927.49C2.307-.723 0 .43 0 2.455"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gmail-standalone_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v18H0z"
  })))));
};
export default SvgGmailStandalone;